import type { Admin } from "@/state/types";

export function canBe(admin: Admin, permisos: readonly string[]) {
  return !!admin.permisos?.find((p1) => permisos.includes(p1));
}
